/** @graphql cc **/

import gql from 'graphql-tag';

export const ArchivedPageBannerQuery = gql`
	query ArchivedPageBannerQuery($contentId: ID) {
		content(id: $contentId, status: ["archived", "current"]) {
			nodes {
				id
				type
				operations {
					operation
					targetType
				}
				archivedContentMetadata {
					archiveNote
				}
				history {
					lastUpdated {
						by {
							... on KnownUser {
								accountId
							}
							... on UnknownUser {
								accountId
							}
						}
					}
				}
			}
		}
	}
`;
